/* Alpha 3D keychain designer: Regular or Smart (NFC), up to four colors.
   Live 3D preview (three.js) plus a paintable front view. On Add to cart it posts the product
   form itself with the design details, a PNG of the front and a ZIP of per-color STL print files.
   Markup and styles live in snippets/alpha-keychain-custom.liquid. */
(function () {
  var FIL = { Black: '#1c1c1c', White: '#f2f0eb', Orange: '#ff6a1a', Gray: '#8c8c8c', Blue: '#2563eb', Red: '#d62828', Yellow: '#f5c518', Green: '#1f9d55', Purple: '#7c3aed', Pink: '#ec4899' };
  var SMART = 'Smart (NFC)';
  var SHAPE_LABEL = { square: 'Rounded square', circle: 'Circle', tag: 'Tag' };
  var PX = 12;     // texture pixels per millimetre
  var CELL = 0.25; // print grid in millimetres (3 texture pixels)
  // Outlines in millimetres, centred on the origin with y up. hole = [x, y, radius], in the top-left corner.
  var SHAPES = {
    square: { w: 48, h: 48, r: 10, round: false, hole: [-18, 18, 2.4] },
    circle: { w: 50, h: 50, r: 25, round: true, hole: [-14.6, 14.6, 2.4] },
    tag: { w: 36, h: 62, r: 9, round: false, hole: [-12.3, 25.3, 2.4] }
  };
  // Print layout: body from 0 to BODY_TOP, design raised RAISE on top, NFC logo inlaid in the bottom BACK_LAYER.
  var BODY_TOP = 3.2, RAISE = 0.8, BACK_LAYER = 0.6;
  var BEVEL = 0.4, RING_R = 6, RING_T = 0.75;
  var MAX_BYTES = 20 * 1024 * 1024;

  function hexToRgb(hex) {
    return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
  }

  function contrastName(name) {
    var c = hexToRgb(FIL[name] || FIL.Black);
    return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255 > 0.55 ? 'Black' : 'White';
  }

  // The keychain outline as a three.js Shape; mirror puts the hole on the other side for the back face.
  function threeShape(T, s, mirror) {
    var shape = new T.Shape();
    if (s.round) {
      shape.absarc(0, 0, s.r, 0, Math.PI * 2, false);
    } else {
      var w = s.w / 2, h = s.h / 2, r = s.r;
      shape.moveTo(-w + r, -h);
      shape.lineTo(w - r, -h); shape.quadraticCurveTo(w, -h, w, -h + r);
      shape.lineTo(w, h - r); shape.quadraticCurveTo(w, h, w - r, h);
      shape.lineTo(-w + r, h); shape.quadraticCurveTo(-w, h, -w, h - r);
      shape.lineTo(-w, -h + r); shape.quadraticCurveTo(-w, -h, -w + r, -h);
    }
    var hole = new T.Path();
    hole.absarc(mirror ? -s.hole[0] : s.hole[0], s.hole[1], s.hole[2], 0, Math.PI * 2, true);
    shape.holes.push(hole);
    return shape;
  }

  // Triangles are stored as [nx, ny, nz, ax, ay, az, bx, by, bz, cx, cy, cz]; addTri fixes the winding to match n.
  function addTri(tris, a, b, c, n) {
    var ux = b[0] - a[0], uy = b[1] - a[1], uz = b[2] - a[2];
    var vx = c[0] - a[0], vy = c[1] - a[1], vz = c[2] - a[2];
    var cx = uy * vz - uz * vy, cy = uz * vx - ux * vz, cz = ux * vy - uy * vx;
    if (cx * n[0] + cy * n[1] + cz * n[2] < 0) { var t = b; b = c; c = t; }
    tris.push([n[0], n[1], n[2], a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]]);
  }

  function addQuad(tris, a, b, c, d, n) {
    addTri(tris, a, b, c, n);
    addTri(tris, a, c, d, n);
  }

  // Closed solid from a grid of filled cells (row 0 at the top), between heights z0 and z1.
  // Faces are emitted per cell so neighbouring faces share whole edges and the mesh stays watertight.
  function meshFromGrid(g, nx, ny, s, z0, z1, tris) {
    var X = function (i) { return i * CELL - s.w / 2; };
    var Y = function (j) { return s.h / 2 - j * CELL; };
    var on = function (i, j) { return i >= 0 && j >= 0 && i < nx && j < ny && g[j * nx + i] === 1; };
    for (var j = 0; j < ny; j++) {
      for (var i = 0; i < nx; i++) {
        if (!on(i, j)) continue;
        var xl = X(i), xr = X(i + 1), yt = Y(j), yb = Y(j + 1);
        addQuad(tris, [xl, yb, z1], [xr, yb, z1], [xr, yt, z1], [xl, yt, z1], [0, 0, 1]);
        addQuad(tris, [xl, yb, z0], [xr, yb, z0], [xr, yt, z0], [xl, yt, z0], [0, 0, -1]);
        if (!on(i, j - 1)) addQuad(tris, [xl, yt, z0], [xr, yt, z0], [xr, yt, z1], [xl, yt, z1], [0, 1, 0]);
        if (!on(i, j + 1)) addQuad(tris, [xl, yb, z0], [xr, yb, z0], [xr, yb, z1], [xl, yb, z1], [0, -1, 0]);
        if (!on(i - 1, j)) addQuad(tris, [xl, yb, z0], [xl, yt, z0], [xl, yt, z1], [xl, yb, z1], [-1, 0, 0]);
        if (!on(i + 1, j)) addQuad(tris, [xr, yb, z0], [xr, yt, z0], [xr, yt, z1], [xr, yb, z1], [1, 0, 0]);
      }
    }
  }

  // Majority filter: each cell takes the most common value around it, which removes thin halos and
  // specks too small to print. With ignoreZero, cells outside the keychain (0) are left alone and not counted.
  function modeFilter(src, w, x0, y0, x1, y1, rad, ignoreZero) {
    var out = new Uint8Array(src), counts = [0, 0, 0, 0, 0];
    for (var y = y0; y < y1; y++) {
      for (var x = x0; x < x1; x++) {
        var i = y * w + x, own = src[i];
        if (ignoreZero && own === 0) continue;
        counts[0] = counts[1] = counts[2] = counts[3] = counts[4] = 0;
        for (var yy = Math.max(y0, y - rad); yy <= Math.min(y1 - 1, y + rad); yy++) {
          for (var xx = Math.max(x0, x - rad); xx <= Math.min(x1 - 1, x + rad); xx++) counts[src[yy * w + xx]]++;
        }
        if (ignoreZero) counts[0] = 0;
        var best = own;
        for (var v = 0; v < 5; v++) if (counts[v] > counts[best]) best = v;
        out[i] = best;
      }
    }
    return out;
  }

  function stlBlob(tris) {
    var buf = new ArrayBuffer(84 + tris.length * 50), dv = new DataView(buf);
    dv.setUint32(80, tris.length, true);
    for (var t = 0, o = 84; t < tris.length; t++, o += 50) {
      for (var q = 0; q < 12; q++) dv.setFloat32(o + q * 4, tris[t][q], true);
      dv.setUint16(o + 48, 0, true);
    }
    return new Blob([buf], { type: 'model/stl' });
  }

  function init() {
    var box = document.getElementById('a3-keychain');
    var form = document.querySelector('form[data-type=add-to-cart-form]');
    if (!box || !form) return;

    // form.id would return the form's <input name=id>, so read the attribute.
    var formId = form.getAttribute('id');
    box.querySelectorAll('input').forEach(function (el) { el.setAttribute('form', formId); });

    var $ = function (sel) { return box.querySelector(sel); };
    var face = $('#kcd-front');
    var back = document.createElement('canvas');
    var work = document.createElement('canvas');
    var view3d = $('#kcd-3d');
    var hint = $('#kcd-hint');
    var flipBtn = $('#kcd-flip');
    var typeNote = $('#kcd-type');
    var paintBar = $('#kcd-paintbar');
    var brushBox = $('#kcd-brush');
    var fileInput = $('#a3k-photo');
    var drop = $('.kcd-drop');
    var tools = $('#kcd-tools');
    var detail = $('#kcd-detail');
    var zoom = $('#kcd-zoom');
    var invert = $('#kcd-invert');
    var textInput = $('#a3k-text');
    var linkField = $('#kcd-link-field');
    var linkInput = $('#a3k-link');
    var err = $('.kcd-err');
    var addButton = form.querySelector('[type=submit][name=add]');

    var state = {
      shape: 'square',
      base: optionValue('Color', 'Black'),
      smart: optionValue('Type', SMART) === SMART,
      count: 1,
      design: [null, 'Orange', 'Blue'],
      textIdx: 2,
      brushIdx: 2,
      brush: 2.5,
      mode: 'move',
      img: null,
      ox: 0,
      oy: 0,
      view: '3d'
    };
    // Per-pixel layers at texture resolution. idx values: 0 outside, 1 keychain color, 2..4 design colors.
    var W = 0, H = 0, L = null;
    var shapeMask, backShape, band, textMask, backLogo, paint, idx, backIdx;
    var three = null, busy = false;

    function optionValue(name, fallback) {
      var checked = document.querySelector('input[type=radio][name=' + name + ']:checked');
      return checked ? checked.value : fallback;
    }

    function designName(i) { return i === 0 && !state.design[0] ? contrastName(state.base) : state.design[i]; }
    function colorName(v) { return v === 1 ? state.base : designName(v - 2); }
    function hexOf(v) { return FIL[colorName(v)] || FIL.Black; }

    // Face layout in texture pixels: art area below the hole, text strip at the bottom.
    function layout(s) {
      var w = s.w * PX, h = s.h * PX;
      var top = (s.h / 2 - s.hole[1] + s.hole[2] + 1.5) * PX;
      var padX = (s.round ? 9 : 4) * PX;
      var bottom = h - (s.round ? 7 : 4) * PX;
      var textH = textInput.value.trim() ? 8 * PX : 0;
      var text = { x: padX, y: bottom - textH, w: w - 2 * padX, h: textH };
      var artBottom = textH ? text.y - 1.5 * PX : bottom;
      return { W: w, H: h, top: top, bottom: bottom, art: { x: padX, y: top, w: w - 2 * padX, h: Math.max(artBottom - top, PX) }, text: text };
    }

    function outline(ctx, s) {
      ctx.beginPath();
      if (s.round) {
        ctx.arc(W / 2, H / 2, W / 2, 0, Math.PI * 2);
        return;
      }
      var r = s.r * PX;
      ctx.moveTo(r, 0);
      ctx.lineTo(W - r, 0); ctx.quadraticCurveTo(W, 0, W, r);
      ctx.lineTo(W, H - r); ctx.quadraticCurveTo(W, H, W - r, H);
      ctx.lineTo(r, H); ctx.quadraticCurveTo(0, H, 0, H - r);
      ctx.lineTo(0, r); ctx.quadraticCurveTo(0, 0, r, 0);
      ctx.closePath();
    }

    function prepare() {
      work.width = W; work.height = H;
      var c = work.getContext('2d');
      c.clearRect(0, 0, W, H);
      return c;
    }

    function readMask() {
      var d = work.getContext('2d').getImageData(0, 0, W, H).data, m = new Uint8Array(W * H);
      for (var i = 0; i < m.length; i++) m[i] = d[i * 4 + 3] > 127 ? 1 : 0;
      return m;
    }

    function shapeMaskFor(s, mirror) {
      var c = prepare();
      c.fillStyle = '#ffffff';
      outline(c, s);
      c.fill();
      c.globalCompositeOperation = 'destination-out';
      var hx = mirror ? -s.hole[0] : s.hole[0];
      c.beginPath();
      c.arc((hx + s.w / 2) * PX, (s.h / 2 - s.hole[1]) * PX, s.hole[2] * PX, 0, Math.PI * 2);
      c.fill();
      c.globalCompositeOperation = 'source-over';
      return readMask();
    }

    // Shades of the uploaded image become bands: the darkest band is design color 1, lighter bands the
    // next colors, and anything lighter than the Detail cut-off stays the keychain color.
    function imageBands() {
      var b = new Uint8Array(W * H);
      if (!state.img) return b;
      var a = L.art, img = state.img;
      var iw = img.naturalWidth || img.width || 1, ih = img.naturalHeight || img.height || 1;
      var scale = Math.min(a.w / iw, a.h / ih) * (zoom.value / 100);
      var dw = iw * scale, dh = ih * scale;
      var c = prepare();
      c.save();
      c.beginPath();
      c.rect(a.x, a.y, a.w, a.h);
      c.clip();
      c.drawImage(img, a.x + (a.w - dw) / 2 + state.ox * PX, a.y + (a.h - dh) / 2 + state.oy * PX, dw, dh);
      c.restore();
      var d = c.getImageData(0, 0, W, H).data;
      var n = state.count, cut = Number(detail.value), step = cut / n, flip = invert.checked;
      var x0 = Math.max(0, Math.floor(a.x)), y0 = Math.max(0, Math.floor(a.y));
      var x1 = Math.min(W, Math.ceil(a.x + a.w)), y1 = Math.min(H, Math.ceil(a.y + a.h));
      for (var y = y0; y < y1; y++) {
        for (var x = x0; x < x1; x++) {
          var i = y * W + x, j = i * 4;
          if (d[j + 3] < 128) continue;
          var lum = 0.299 * d[j] + 0.587 * d[j + 1] + 0.114 * d[j + 2];
          if (flip) lum = 255 - lum;
          if (lum < cut) b[i] = 1 + Math.min(n - 1, Math.floor(lum / step));
        }
      }
      // Clean up anti-aliased edges between shades so the preview matches what can be printed.
      return modeFilter(b, W, x0, y0, x1, y1, 2, false);
    }

    function fitFont(c, text, maxW, size, weight) {
      c.font = weight + ' ' + size + 'px Arial Black, Arial, sans-serif';
      while (c.measureText(text).width > maxW && size > 8) {
        size -= 1;
        c.font = weight + ' ' + size + 'px Arial Black, Arial, sans-serif';
      }
      return size;
    }

    function textLayer() {
      var c = prepare();
      if (L.text.h) {
        var t = textInput.value.trim();
        c.fillStyle = '#ffffff';
        c.textAlign = 'center';
        c.textBaseline = 'middle';
        fitFont(c, t, L.text.w, L.text.h * 0.92, '900');
        c.fillText(t, L.text.x + L.text.w / 2, L.text.y + L.text.h / 2);
      }
      return readMask();
    }

    // Back of a Smart keychain: a generic contactless tap symbol with NFC and TAP TO CONNECT.
    function nfcLayer() {
      var c = prepare();
      var avail = L.bottom - L.top, R = Math.min(avail * 0.34, W * 0.24);
      var cy = L.top + avail * 0.36, cx = W / 2 - R * 0.58;
      c.strokeStyle = '#ffffff';
      c.fillStyle = '#ffffff';
      c.lineCap = 'round';
      c.lineWidth = R * 0.14;
      for (var k = 1; k <= 4; k++) {
        c.beginPath();
        c.arc(cx, cy, R * k / 4, -0.9, 0.9);
        c.stroke();
      }
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      var maxW = W * (W > H ? 0.6 : 0.7);
      var big = fitFont(c, 'NFC', maxW, R * 0.8, '900');
      var y = cy + R * 0.95 + big * 0.5;
      c.fillText('NFC', W / 2, y);
      var small = fitFont(c, 'TAP TO CONNECT', maxW, big * 0.36, '700');
      c.fillText('TAP TO CONNECT', W / 2, y + big * 0.5 + small * 0.9);
      return readMask();
    }

    function rebuildLayers() {
      var s = SHAPES[state.shape];
      L = layout(s);
      if (L.W !== W || L.H !== H) { W = L.W; H = L.H; paint = new Uint8Array(W * H); }
      shapeMask = shapeMaskFor(s, false);
      backShape = shapeMaskFor(s, true);
      band = imageBands();
      textMask = textLayer();
      backLogo = nfcLayer();
      compose();
    }

    function compose() {
      var n = W * H, max = state.count + 1, t = Math.min(state.textIdx, max);
      if (!idx || idx.length !== n) { idx = new Uint8Array(n); backIdx = new Uint8Array(n); }
      for (var i = 0; i < n; i++) {
        if (!shapeMask[i]) idx[i] = 0;
        else if (paint[i] && paint[i] <= max) idx[i] = paint[i];
        else if (textMask[i]) idx[i] = t;
        else if (band[i]) idx[i] = 1 + band[i];
        else idx[i] = 1;
        backIdx[i] = !backShape[i] ? 0 : (state.smart && backLogo[i] ? 2 : 1);
      }
      render(face, idx);
      render(back, backIdx);
      if (three) three.refresh();
    }

    function render(canvas, arr) {
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      var ctx = canvas.getContext('2d'), out = ctx.createImageData(W, H), d = out.data;
      var rgb = [null, hexToRgb(hexOf(1)), hexToRgb(hexOf(2)), hexToRgb(hexOf(3)), hexToRgb(hexOf(4))];
      for (var y = 0; y < H; y++) {
        var shade = y % 3 === 0 ? 0.94 : 1; // faint layer lines, like a real print
        for (var x = 0; x < W; x++) {
          var i = y * W + x, v = arr[i], j = i * 4;
          if (!v) { d[j + 3] = 0; continue; }
          d[j] = rgb[v][0] * shade;
          d[j + 1] = rgb[v][1] * shade;
          d[j + 2] = rgb[v][2] * shade;
          d[j + 3] = 255;
        }
      }
      ctx.putImageData(out, 0, 0);
    }

    // Painting on the front view writes straight into the paint layer.
    function stamp(cx, cy) {
      var r = state.brush * PX, r2 = r * r, v = state.brushIdx;
      var x0 = Math.max(0, Math.floor(cx - r)), x1 = Math.min(W - 1, Math.ceil(cx + r));
      var y0 = Math.max(0, Math.floor(cy - r)), y1 = Math.min(H - 1, Math.ceil(cy + r));
      for (var y = y0; y <= y1; y++) {
        for (var x = x0; x <= x1; x++) {
          var dx = x - cx, dy = y - cy;
          if (dx * dx + dy * dy <= r2) paint[y * W + x] = v;
        }
      }
    }

    function stroke(x0, y0, x1, y1) {
      var steps = Math.max(1, Math.ceil(Math.hypot(x1 - x0, y1 - y0) / (state.brush * PX * 0.4)));
      for (var k = 0; k <= steps; k++) stamp(x0 + (x1 - x0) * k / steps, y0 + (y1 - y0) * k / steps);
      compose();
    }

    function swatch(name, hex, selected, onPick, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kcd-sw' + (selected ? ' is-on' : '');
      b.style.setProperty('--c', hex);
      b.title = label || name;
      b.setAttribute('aria-label', label || name);
      b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      b.addEventListener('click', onPick);
      return b;
    }

    // Palette rows for the design colors, plus text and brush choices that follow the active colors.
    function renderColorUI() {
      var max = state.count + 1;
      if (state.textIdx > max) state.textIdx = 2;
      if (state.brushIdx > max) state.brushIdx = 2;
      var rows = $('#kcd-palettes');
      rows.innerHTML = '';
      for (var i = 0; i < state.count; i++) {
        (function (slot) {
          var row = document.createElement('div');
          row.className = 'kcd-prow';
          var lab = document.createElement('span');
          lab.className = 'kcd-plabel';
          lab.textContent = 'Color ' + (slot + 2);
          var list = document.createElement('div');
          list.className = 'kcd-swatches';
          if (slot === 0) {
            var auto = swatch('Auto', FIL[contrastName(state.base)], !state.design[0], function () { state.design[0] = null; renderColorUI(); compose(); }, 'Auto, best contrast');
            auto.classList.add('kcd-sw--auto');
            auto.textContent = 'A';
            list.appendChild(auto);
          }
          Object.keys(FIL).forEach(function (name) {
            list.appendChild(swatch(name, FIL[name], state.design[slot] === name, function () { state.design[slot] = name; renderColorUI(); compose(); }));
          });
          var nm = document.createElement('span');
          nm.className = 'kcd-pname';
          nm.textContent = designName(slot) + (slot === 0 && !state.design[0] ? ' (auto)' : '');
          row.appendChild(lab);
          row.appendChild(list);
          row.appendChild(nm);
          rows.appendChild(row);
        })(i);
      }
      var tl = $('#kcd-text-color');
      tl.innerHTML = '';
      for (var v = 2; v <= max; v++) {
        (function (val) {
          tl.appendChild(swatch(colorName(val), hexOf(val), state.textIdx === val, function () { state.textIdx = val; renderColorUI(); compose(); }, 'Text in ' + colorName(val)));
        })(v);
      }
      var bl = $('#kcd-brush-colors');
      bl.innerHTML = '';
      for (var u = 1; u <= max; u++) {
        (function (val) {
          bl.appendChild(swatch(colorName(val), hexOf(val), state.brushIdx === val, function () { state.brushIdx = val; renderColorUI(); }, 'Paint with ' + colorName(val) + (val === 1 ? ' (keychain color)' : '')));
        })(u);
      }
    }

    function setupThree() {
      var T = window.THREE, renderer;
      try {
        renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
      } catch (e) {
        return null;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = T.sRGBEncoding;
      view3d.appendChild(renderer.domElement);

      var scene = new T.Scene();
      var camera = new T.PerspectiveCamera(30, 1, 1, 2000);
      scene.add(new T.HemisphereLight(0xffffff, 0x9a948a, 0.95));
      var sun = new T.DirectionalLight(0xffffff, 0.75);
      sun.position.set(50, 80, 120);
      scene.add(sun);
      var rim = new T.DirectionalLight(0xffffff, 0.45);
      rim.position.set(-40, 40, -120);
      scene.add(rim);

      var group = new T.Group();
      scene.add(group);
      function canvasTexture(c) {
        var t = new T.CanvasTexture(c);
        t.encoding = T.sRGBEncoding;
        t.anisotropy = 4;
        return t;
      }
      var frontTex = canvasTexture(face);
      var backTex = canvasTexture(back);
      var bodyMat = new T.MeshStandardMaterial({ roughness: 0.55, metalness: 0 });
      var faceMat = new T.MeshStandardMaterial({ map: frontTex, roughness: 0.5, transparent: true });
      var backMat = new T.MeshStandardMaterial({ map: backTex, roughness: 0.5, transparent: true });
      var ringMat = new T.MeshStandardMaterial({ color: 0xc4c8cc, metalness: 0.9, roughness: 0.28 });
      var parts = [];

      // ShapeGeometry UVs are in millimetres; map them onto the 0..1 face texture.
      function faceGeometry(shape, s) {
        var g = new T.ShapeGeometry(shape, 48);
        var uv = g.attributes.uv;
        for (var i = 0; i < uv.count; i++) uv.setXY(i, uv.getX(i) / s.w + 0.5, uv.getY(i) / s.h + 0.5);
        uv.needsUpdate = true;
        return g;
      }

      function rebuild() {
        parts.forEach(function (p) {
          group.remove(p);
          p.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
        });
        var s = SHAPES[state.shape];
        var depth = BODY_TOP - 2 * BEVEL;
        var bodyGeo = new T.ExtrudeGeometry(threeShape(T, s, false), { depth: depth, bevelEnabled: true, bevelThickness: BEVEL, bevelSize: BEVEL, bevelSegments: 3, curveSegments: 48 });
        bodyGeo.translate(0, 0, -depth / 2);
        var zFace = depth / 2 + BEVEL + 0.02;
        var body = new T.Mesh(bodyGeo, bodyMat);
        var front = new T.Mesh(faceGeometry(threeShape(T, s, false), s), faceMat);
        front.position.z = zFace;
        // The back is the mirrored outline turned around, so it reads correctly from behind and its hole lines up.
        var backMesh = new T.Mesh(faceGeometry(threeShape(T, s, true), s), backMat);
        backMesh.rotation.y = Math.PI;
        backMesh.position.z = -zFace;
        // Key ring through the corner hole, angled out from the centre.
        var hx = s.hole[0], hy = s.hole[1], len = Math.hypot(hx, hy) || 1, dx = hx / len, dy = hy / len;
        var pivot = new T.Group();
        pivot.position.set(hx, hy, 0);
        pivot.rotation.z = Math.atan2(-dx, dy);
        var ring = new T.Mesh(new T.TorusGeometry(RING_R, RING_T, 16, 56), ringMat);
        ring.rotation.y = Math.PI / 2;
        ring.position.y = RING_R - 0.4;
        pivot.add(ring);
        parts = [body, front, backMesh, pivot];
        parts.forEach(function (p) { group.add(p); });
        var farX = hx + dx * (2 * RING_R + RING_T), farY = hy + dy * (2 * RING_R + RING_T);
        var minX = Math.min(-s.w / 2, farX), maxX = s.w / 2, minY = -s.h / 2, maxY = Math.max(s.h / 2, farY);
        group.position.set(-(minX + maxX) / 2, -(minY + maxY) / 2, 0);
        camera.position.set(0, 0, Math.max(maxX - minX, maxY - minY) * 2.3);
        camera.lookAt(0, 0, 0);
        refresh();
      }

      function refresh() {
        bodyMat.color.copy(new T.Color(FIL[state.base] || FIL.Black).convertSRGBToLinear());
        frontTex.needsUpdate = true;
        backTex.needsUpdate = true;
      }

      function resize() {
        var r = view3d.getBoundingClientRect();
        if (!r.width || !r.height) return;
        renderer.setSize(r.width, r.height, false);
        camera.aspect = r.width / r.height;
        camera.updateProjectionMatrix();
      }

      // Drag to spin; when idle it sways gently around whichever side faces the viewer.
      var rotY = -0.45, rotX = 0.12, dragging = false, lastX = 0, lastY = 0, lastTouch = 0, flipTo = null;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var canvas = renderer.domElement;
      canvas.addEventListener('pointerdown', function (e) {
        dragging = true; flipTo = null; lastX = e.clientX; lastY = e.clientY;
        if (canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        rotY += (e.clientX - lastX) * 0.012;
        rotX = Math.max(-0.8, Math.min(0.8, rotX + (e.clientY - lastY) * 0.008));
        lastX = e.clientX; lastY = e.clientY; lastTouch = Date.now();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
        canvas.addEventListener(t, function () { dragging = false; lastTouch = Date.now(); });
      });

      function facingBack() {
        var a = ((rotY % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
        return a > Math.PI / 2 && a < 3 * Math.PI / 2;
      }

      function flip() {
        flipTo = Math.round(rotY / Math.PI) * Math.PI + Math.PI;
        lastTouch = Date.now() + 1500;
      }

      var visible = true, wasBack = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(view3d);
      }
      function loop(now) {
        requestAnimationFrame(loop);
        if (!visible || state.view !== '3d') return;
        if (flipTo !== null) {
          rotY += (flipTo - rotY) * 0.1;
          rotX += (0.12 - rotX) * 0.1;
          if (Math.abs(flipTo - rotY) < 0.01) flipTo = null;
        } else if (!dragging && !still && Date.now() - lastTouch > 2500) {
          var base = Math.round(rotY / Math.PI) * Math.PI;
          rotY += (base + Math.sin(now / 1700) * 0.6 - rotY) * 0.02;
          rotX += (0.12 - rotX) * 0.03;
        }
        group.rotation.set(rotX, rotY, 0);
        var isBack = facingBack();
        if (isBack !== wasBack) {
          wasBack = isBack;
          flipBtn.textContent = isBack ? 'Flip to front' : 'Flip to back';
        }
        renderer.render(scene, camera);
      }

      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(view3d);
      window.addEventListener('resize', resize);
      resize();
      rebuild();
      requestAnimationFrame(loop);
      return { rebuild: rebuild, refresh: refresh, flip: flip };
    }

    function updateHint() {
      if (state.view === '3d') hint.textContent = 'Drag to spin';
      else if (state.mode === 'paint') hint.textContent = 'Paint on your keychain';
      else hint.textContent = state.img ? 'Drag your image to position it' : 'Front view';
      face.style.cursor = state.mode === 'paint' ? 'crosshair' : 'move';
    }

    function setView(view) {
      state.view = three ? view : 'front';
      view3d.hidden = state.view !== '3d';
      face.hidden = state.view !== 'front';
      flipBtn.hidden = state.view !== '3d';
      paintBar.hidden = state.view !== 'front';
      box.querySelectorAll('#kcd-toggle button').forEach(function (b) { b.classList.toggle('is-on', b.dataset.view === state.view); });
      updateHint();
    }

    // Smart keychains need a link and show the NFC mark on the back; Regular ones do not.
    function applyType() {
      linkField.hidden = !state.smart;
      typeNote.innerHTML = state.smart
        ? '<strong>Smart (NFC):</strong> chip inside, tap logo on the back. Flip the 3D view to see it.'
        : '<strong>Regular:</strong> your design on the front, plain back, no chip.';
      clearError();
    }

    function chips(sel, onPick) {
      $(sel).addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        $(sel).querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        onPick(b);
      });
    }

    function showError(msg, field) {
      err.textContent = msg;
      err.hidden = false;
      if (field) { field.classList.add('is-invalid'); field.focus({ preventScroll: true }); }
      err.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function clearError() {
      err.hidden = true;
      linkInput.classList.remove('is-invalid');
    }

    function loadFile() {
      clearError();
      var file = fileInput.files[0];
      state.img = null; state.ox = 0; state.oy = 0;
      if (!file) {
        drop.classList.remove('is-filled');
        $('.kcd-drop__ui').hidden = false;
        $('.kcd-drop__file').hidden = true;
        tools.hidden = true;
        updateHint();
        rebuildLayers();
        return;
      }
      if (file.size > MAX_BYTES) {
        fileInput.value = '';
        loadFile();
        showError('That file is over 20 MB. Please choose a smaller version.');
        return;
      }
      $('.kcd-drop__name').textContent = file.name;
      $('.kcd-drop__ui').hidden = true;
      $('.kcd-drop__file').hidden = false;
      drop.classList.add('is-filled');
      var img = new Image();
      img.onload = function () { state.img = img; tools.hidden = false; updateHint(); rebuildLayers(); };
      img.onerror = function () { showError('This file cannot be previewed. Please upload a JPG or PNG.'); };
      img.src = URL.createObjectURL(file);
    }

    // Accept mysite.com as well as full URLs; add https:// when the scheme is missing.
    function normalizeLink(value) {
      var v = value.trim();
      if (!v) return '';
      var lower = v.toLowerCase();
      if (v.indexOf('://') === -1 && lower.indexOf('mailto:') !== 0 && lower.indexOf('tel:') !== 0) v = 'https://' + v;
      try {
        var u = new URL(v);
        if ((u.protocol === 'http:' || u.protocol === 'https:') && u.hostname.indexOf('.') === -1) return null;
        return u.href;
      } catch (e) {
        return null;
      }
    }

    // Color grid of print cells (CELL mm) sampled from a texture layer, with specks too small to print removed.
    // mirror flips the back so it reads correctly from the front.
    function sampleGrid(arr, mirror, nx, ny) {
      var g = new Uint8Array(nx * ny);
      for (var iy = 0; iy < ny; iy++) {
        var py = Math.min(H - 1, Math.floor((iy + 0.5) * CELL * PX));
        for (var ix = 0; ix < nx; ix++) {
          var sx = mirror ? nx - 1 - ix : ix;
          g[iy * nx + ix] = arr[py * W + Math.min(W - 1, Math.floor((sx + 0.5) * CELL * PX))];
        }
      }
      return modeFilter(g, nx, 0, 0, nx, ny, 1, true);
    }

    function maskOf(g, test) {
      var m = new Uint8Array(g.length), any = false;
      for (var i = 0; i < g.length; i++) if (test(g[i])) { m[i] = 1; any = true; }
      return any ? m : null;
    }

    function bodyTris(s, z0, nx, ny, frontGrid, tris) {
      var T = window.THREE;
      if (!T) {
        meshFromGrid(maskOf(frontGrid, function (v) { return v !== 0; }), nx, ny, s, z0, BODY_TOP, tris);
        return;
      }
      var geo = new T.ExtrudeGeometry(threeShape(T, s, false), { depth: BODY_TOP - z0, bevelEnabled: false, curveSegments: 64 });
      geo.translate(0, 0, z0);
      if (geo.index) geo = geo.toNonIndexed();
      var p = geo.attributes.position.array;
      for (var k = 0; k < p.length; k += 9) {
        var ux = p[k + 3] - p[k], uy = p[k + 4] - p[k + 1], uz = p[k + 5] - p[k + 2];
        var vx = p[k + 6] - p[k], vy = p[k + 7] - p[k + 1], vz = p[k + 8] - p[k + 2];
        var nx3 = uy * vz - uz * vy, ny3 = uz * vx - ux * vz, nz3 = ux * vy - uy * vx;
        var nl = Math.hypot(nx3, ny3, nz3) || 1;
        tris.push([nx3 / nl, ny3 / nl, nz3 / nl, p[k], p[k + 1], p[k + 2], p[k + 3], p[k + 4], p[k + 5], p[k + 6], p[k + 7], p[k + 8]]);
      }
      geo.dispose();
    }

    // One STL per filament color, ready to load together as a multi-part object in the slicer.
    function buildPrintZip() {
      if (!window.JSZip) return Promise.resolve(null);
      var s = SHAPES[state.shape], nx = Math.round(s.w / CELL), ny = Math.round(s.h / CELL);
      var zip = new window.JSZip(), lines = [], n = 1;
      function add(label, color, tris) {
        if (!tris.length) return;
        var name = n + '-' + label + '-' + color.toLowerCase() + '.stl';
        zip.file(name, stlBlob(tris));
        lines.push('  ' + name + '  ->  ' + color + ' filament');
        n++;
      }
      function part(grid, value, z0, z1, label, color) {
        var m = maskOf(grid, function (x) { return x === value; });
        if (!m) return;
        var tris = [];
        meshFromGrid(m, nx, ny, s, z0, z1, tris);
        add(label, color, tris);
      }
      var front = sampleGrid(idx, false, nx, ny);
      var bodyStart = state.smart ? BACK_LAYER : 0;
      var body = [];
      bodyTris(s, bodyStart, nx, ny, front, body);
      add('body', state.base, body);
      for (var v = 2; v <= state.count + 1; v++) part(front, v, BODY_TOP, BODY_TOP + RAISE, 'design', colorName(v));
      if (state.smart) {
        var rear = sampleGrid(backIdx, true, nx, ny);
        part(rear, 1, 0, BACK_LAYER, 'back', state.base);
        part(rear, 2, 0, BACK_LAYER, 'nfc-logo', colorName(2));
      }
      var readme = [
        'Alpha 3D Printing Co. keychain print files',
        '',
        'Shape: ' + SHAPE_LABEL[state.shape] + ' (' + s.w + ' x ' + s.h + ' mm)',
        'Type: ' + (state.smart ? SMART : 'Regular'),
        'Units: millimetres. Text: ' + (textInput.value.trim() || 'none'),
        '',
        'Load all STL files at once in Bambu Studio, OrcaSlicer or PrusaSlicer and choose to load',
        'them as a single object with multiple parts, then set each part to its filament:',
        lines.join('\n'),
        '',
        'Layers: ' + (state.smart ? 'NFC logo inlay 0-' + BACK_LAYER + ' mm (bed side), ' : '') + 'body ' + bodyStart + '-' + BODY_TOP + ' mm, raised design ' + BODY_TOP + '-' + (BODY_TOP + RAISE) + ' mm.',
        state.smart ? 'NFC: add a pause at about 2 mm, place the programmed NFC sticker tag in the middle, then resume.' : ''
      ].join('\n');
      zip.file('README.txt', readme);
      return zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
    }

    function setBusy(on) {
      busy = on;
      if (!addButton) return;
      addButton.classList.toggle('loading', on);
      if (on) { addButton.setAttribute('aria-disabled', 'true'); } else { addButton.removeAttribute('aria-disabled'); }
    }

    function post(fd) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok && !data.status, data: data }; }); });
    }

    function formData(png, zipBlob) {
      var max = state.count + 1, colors = ['Keychain: ' + state.base];
      for (var v = 2; v <= max; v++) colors.push('Color ' + v + ': ' + colorName(v));
      var fd = new FormData(form);
      if (!state.smart) fd.delete('properties[NFC link]');
      if (!textInput.value.trim()) fd.delete('properties[Text]');
      if (!fileInput.files.length) fd.delete('properties[Photo or logo]');
      fd.append('properties[Shape]', SHAPE_LABEL[state.shape]);
      fd.append('properties[Colors]', colors.join(', '));
      fd.append('properties[Back]', state.smart ? 'NFC tap logo in ' + colorName(2) : 'Plain');
      if (png) fd.append('properties[Design preview]', new File([png], 'keychain-design.png', { type: 'image/png' }));
      if (zipBlob) fd.append('properties[Print files]', new File([zipBlob], 'keychain-print-files.zip', { type: 'application/zip' }));
      return fd;
    }

    function addToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      clearError();
      if (state.smart) {
        var link = normalizeLink(linkInput.value);
        if (link === '') { showError('Please enter the link you want your keychain to open.', linkInput); return; }
        if (link === null) { showError('That link does not look right. Try something like yourwebsite.com or https://instagram.com/yourname.', linkInput); return; }
        linkInput.value = link;
      }
      setBusy(true);
      var png = null;
      new Promise(function (resolve) { face.toBlob(resolve, 'image/png'); })
        .then(function (blob) { png = blob; return buildPrintZip().catch(function () { return null; }); })
        // If the print files are refused for any reason, still add the keychain with its design.
        .then(function (zipBlob) { return post(formData(png, zipBlob)).then(function (r) { return r.ok || !zipBlob ? r : post(formData(png, null)); }); })
        .then(function (r) {
          if (!r.ok) {
            setBusy(false);
            showError(r.data.description || 'Something went wrong adding this to your cart. Please try again.');
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          showError('Your keychain could not be added. Check your connection and try again.');
        });
    }

    // Wire up controls.
    $('#kcd-toggle').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) setView(b.dataset.view);
    });
    flipBtn.addEventListener('click', function () { if (three) three.flip(); });
    chips('#kcd-shape', function (b) {
      state.shape = b.dataset.shape;
      state.ox = 0; state.oy = 0;
      rebuildLayers();
      if (three) three.rebuild();
    });
    chips('#kcd-count', function (b) {
      state.count = Number(b.dataset.count);
      renderColorUI();
      band = imageBands();
      compose();
    });
    chips('#kcd-mode', function (b) {
      state.mode = b.dataset.mode;
      brushBox.hidden = state.mode !== 'paint';
      updateHint();
    });
    $('#kcd-brush-size').addEventListener('input', function (e) { state.brush = Number(e.target.value); });
    $('#kcd-clear-paint').addEventListener('click', function () { paint.fill(0); compose(); });
    fileInput.addEventListener('change', loadFile);
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    $('.kcd-drop__clear').addEventListener('click', function () { fileInput.value = ''; loadFile(); });
    [detail, zoom, invert].forEach(function (el) {
      el.addEventListener('input', function () { band = imageBands(); compose(); });
      el.addEventListener('change', function () { band = imageBands(); compose(); });
    });
    textInput.addEventListener('input', function () {
      $('#a3k-count').textContent = 20 - textInput.value.length;
      rebuildLayers();
    });
    linkInput.addEventListener('input', clearError);
    document.addEventListener('change', function (e) {
      if (e.target.name === 'Color' && FIL[e.target.value]) { state.base = e.target.value; renderColorUI(); compose(); }
      if (e.target.name === 'Type') { state.smart = e.target.value === SMART; applyType(); compose(); }
    });

    // Front view: drag to move the image, or paint when Paint is on.
    var drag = null;
    function point(e) {
      var r = face.getBoundingClientRect();
      return { x: (e.clientX - r.left) * W / r.width, y: (e.clientY - r.top) * H / r.height };
    }
    face.addEventListener('pointerdown', function (e) {
      if (state.mode === 'move' && !state.img) return;
      drag = point(e);
      face.setPointerCapture(e.pointerId);
      if (state.mode === 'paint') stroke(drag.x, drag.y, drag.x, drag.y);
    });
    face.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = point(e);
      if (state.mode === 'paint') {
        stroke(drag.x, drag.y, p.x, p.y);
      } else {
        state.ox += (p.x - drag.x) / PX;
        state.oy += (p.y - drag.y) / PX;
        band = imageBands();
        compose();
      }
      drag = p;
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { face.addEventListener(t, function () { drag = null; }); });

    // Capture phase on document runs before the theme's and any app's handlers on the button or form.
    document.addEventListener('click', function (e) {
      if (addButton && e.target.closest && e.target.closest('[type=submit][name=add]') === addButton) addToCart(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target === form) addToCart(e);
    }, true);

    renderColorUI();
    applyType();
    rebuildLayers();
    if (window.THREE) three = setupThree();
    setView(three ? '3d' : 'front');
    if (!three) $('#kcd-toggle').hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
